import { http } from 'services/http';
import {
  CARGO_ITEMS_MANY,
  CARGO_TRIPS_MANY,
  TRANSPORTS_LIST,
  TRIP_ARRIVAL_INFORMATION,
  TRIP_GET_ONE,
  TRIP_TASKS_GET_MANY,
} from 'api/query-keys.ts';
import type { TripRes, UpdateTripStatusReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateTripStatus = (tripId: number) => {
  return useMutationBase<TripRes, unknown, UpdateTripStatusReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TripRes>(`/v1/trips/${tripId}/status`, variables);

      return res.data;
    },

    invalidateCallback: (data) => [
      [TRIP_GET_ONE, data.id],
      [TRIP_ARRIVAL_INFORMATION, data.id],
      [CARGO_TRIPS_MANY, data.id],
      [CARGO_ITEMS_MANY],
      [TRANSPORTS_LIST],
      [TRIP_TASKS_GET_MANY, data.id],
    ],
  });
};
